import React, { useMemo } from 'react';
import HeroSlider from '../ui/HeroSlider';
import SectionHeading from '../ui/SectionHeading';
import Card from '../ui/Card';
import ImageGallery from '../ui/ImageGallery';
import { aboutText } from '../../data/company';
import { homepageFeatures } from '../../data/products';
import { galleryImages } from '../../data/gallery';
import { useBetaProgram } from '../../beta/hooks';

const HomePage = () => {
  const { program } = useBetaProgram();

  const homepageCards = useMemo(() => {
    if (!program?.features?.sampleCatalog) {
      return homepageFeatures;
    }

    return [
      ...homepageFeatures,
      {
        id: 'sample-program',
        title: 'SAMPLE ORDERING',
        description:
          'Order trial packs directly from the site and route approved requests to fulfillment automatically.',
        image: '/images/gallery/chef-creating-dessert.jpeg',
        link: '/samples'
      }
    ];
  }, [program]);

  return (
    <div>
      {/* Hero Section */}
      <HeroSlider />

      {/* About Section */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <SectionHeading title="About Mirage Desserts" />
          <p className="text-gray-600 leading-relaxed">
            {aboutText.homepage}
          </p>
        </div>
      </section>

      {/* Products and Services Grid */}
      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <SectionHeading title="MIRAGE PRODUCTS AND SERVICES" />
          <div
            className={`grid grid-cols-1 md:grid-cols-2 gap-8 ${
              homepageCards.length > 4 ? 'lg:grid-cols-3 xl:grid-cols-5' : 'lg:grid-cols-4'
            }`}
          >
            {homepageCards.map((feature) => (
              <Card
                key={feature.id}
                variant="circular"
                title={feature.title}
                description={feature.description}
                image={feature.image}
                link={feature.link}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Superior Products Section */}
      <section className="py-20 px-6 bg-cover bg-center relative" style={{ backgroundImage: 'url(/images/hero/sweet-wallpaper.jpg)' }}>
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4">Superior Products</h2>
          <div className="w-16 h-1 bg-primary-red mx-auto mb-6" />
          <p className="text-lg leading-relaxed">
            {aboutText.superiorProducts}
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <SectionHeading title="Our Gallery" />
          <ImageGallery images={galleryImages} />
        </div>
      </section>
    </div>
  );
};

export default HomePage;
